import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { SearchBulkFacadeService } from './search-bulk.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchBulkService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
    private searchBulkFacadeService: SearchBulkFacadeService,
  ) {}

  searchBulk(): Observable<QcResponseGrid> {
    const url = this.environmentFacadeService.getEnvironment() + '/rest/v1/import/search/configurations';

    return this.http.post<QcResponseGrid>(
      url,
      {
        criteriaList: [
          {
            criteriaType: 'BULK_ACTIONS_TITLE_CRITERIA',
            importTittle: this.searchBulkFacadeService.configurationName,
          },
          {
            criteriaType: 'BULK_ACTIONS_MODEL_PROFILE_CRITERIA',
            importModelProfile:
              this.searchBulkFacadeService.profileModel !== '' ? this.searchBulkFacadeService.profileModel : '',
          },
          {
            criteriaType: 'BULK_ACTIONS_DELETEFLAG_CRITERIA',
            deleteFlag: !this.searchBulkFacadeService.isActive,
          },
        ],
        pagination: {
          page: this.paginatorFacadeService.pageIndex + 1,
          pageSize: this.paginatorFacadeService.itemsNumber,
        },
        sorting: {
          sortingField: 'FLOW_CREATION_DATE',
          sortingOrder:
            this.paginatorFacadeService.selectedOrder ===
            this.literalsFacade.literals.literals['liquid.search.sort.asc']
              ? 'ASC'
              : 'DESC',
        },
      },
      { withCredentials: true, context: new HttpContext().set(IS_SEARCH, true) },
    );
  }
}
